import ResultImportCard from './ResultImportCard'

export default ResultImportCard
